<template>
  <section class="bg-rose-50 shadow overflow-hidden sm:rounded-lg">
    <div class="flex flex-col items-start gap-y-6 gap-x-8 p-8 ring-1 ring-gray-900/10 sm:gap-y-10 sm:p-10 lg:col-span-2 lg:flex-row lg:items-center">
      <div class="lg:min-w-0 lg:flex-1">
        <h3 class="text-lg font-semibold leading-8 tracking-tight text-red-500">
          Es ist zu einem unerwarteten Fehler gekommen
        </h3>
        <p class="mt-1 text-base leading-7 text-gray-600">
          Das hätte eigentlich nicht passieren sollen... <br/>
          Fall du dir unsicher bist, warum dieser Fehler aufgetreten ist, kannst du dich gerne kurz bei uns melden.
        </p>
      </div>
      <a href="mailto:feedback@sanktaudio.com" class="button-error">
        Fehler melden
      </a>
    </div>
  </section>
</template>
